'use client';

import { Button } from '@common/atoms/Button';
import { type LocaleID, type PlatformID } from '@common/clients/api';
import { getT, Ns } from '@web/i18n';

import { MainContent } from './atoms/MainContent';
import { ErrorText } from './molecules/ErrorText';
import { ErrorIntroBlock } from './organisms/ErrorIntroBlock';

import styles from './DefaultErrorView.module.scss';

interface Props {
    localeID: LocaleID;
    platformID: PlatformID;
}

export const DefaultErrorView = ({ localeID, platformID }: Props) => {
    const __error = getT(localeID, Ns.Error);
    const statusCodeAlias = __error('statusCodeAlias');
    const description = __error('description');
    const subtitle = __error('subtitle');
    const buttonLabel = __error('buttonLabel');
    return (
        <div className={styles['DefaultErrorView']}>
            <MainContent>
                <title>500 - {statusCodeAlias}</title>
                <ErrorIntroBlock platformID={platformID}>
                    <ErrorText content={{ errorCode: 500, description, subtitle }} />
                    <Button href="/" variant="filled-primary" className="error-button" hardRefresh>
                        {buttonLabel}
                    </Button>
                </ErrorIntroBlock>
            </MainContent>
        </div>
    );
};
